// Import the functions you need from the SDKs you need
import { FIREBASE_CONFIG } from "@shared/firebase-api";
import { initializeApp } from "firebase/app";
import { CONFIG } from "src/config";

// Not IS_PROD: a local dev server can be pointed at production on purpose via
// `yarn dev:prod`. See CONFIG.BACKEND.
const config = CONFIG.USES_PROD_BACKEND ? FIREBASE_CONFIG.PROD : FIREBASE_CONFIG.DEV;

console.log("projectId", config.projectId);

if (CONFIG.IS_LOCAL_ON_PROD) {
	console.warn(
		"%c⚠ LOCAL CLIENT CONNECTED TO PRODUCTION (cana-prod) — every write hits real customer data.",
		"background:#b91c1c;color:#fff;font-size:14px;font-weight:bold;padding:4px 8px;",
	);
}

// Initialize Firebase
export const app = initializeApp(config);
